import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UserIcon, CreditCardIcon, ClockIcon, MapPinIcon } from 'lucide-react';
const Dashboard: React.FC = () => {
  return <div className="px-4 py-6" data-id="element-27">
      <div className="mb-6" data-id="element-28">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-29">
          Welcome, Ahmed
        </h1>
        <p className="text-gray-600 dark:text-gray-400" data-id="element-30">Have a great day!</p>
      </div>
      {/* Upcoming Duty Card */}
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 mb-6" data-id="element-31">
        <div className="flex items-center justify-between mb-3" data-id="element-32">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white" data-id="element-33">
            Upcoming Duty
          </h2>
          <Link to="/duties" className="text-sm text-blue-600 dark:text-blue-400" data-id="element-34">
            View all
          </Link>
        </div>
        <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-100 dark:border-blue-800 rounded-lg p-4" data-id="element-35">
          <div className="flex items-center mb-3" data-id="element-36">
            <div className="w-10 h-10 bg-blue-100 dark:bg-blue-800 rounded-full flex items-center justify-center mr-3" data-id="element-37">
              <CalendarIcon className="w-5 h-5 text-blue-600 dark:text-blue-300" data-id="element-38" />
            </div>
            <div data-id="element-39">
              <h3 className="font-semibold text-gray-900 dark:text-white" data-id="element-40">
                Masjid Security
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-41">
                Main Entrance
              </p>
            </div>
          </div>
          <div className="flex items-center text-sm text-gray-700 dark:text-gray-300 mb-2" data-id="element-42">
            <ClockIcon className="w-4 h-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-43" />
            <span data-id="element-44">Today, 7:00 PM - 9:00 PM</span>
          </div>
          <div className="flex items-center text-sm text-gray-700 dark:text-gray-300" data-id="element-45">
            <MapPinIcon className="w-4 h-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-46" />
            <span data-id="element-47">Burhani Masjid, Dahod</span>
          </div>
        </div>
      </div>
      {/* Quick Links */}
      <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-3" data-id="element-48">
        Quick Access
      </h2>
      <div className="grid grid-cols-2 gap-4" data-id="element-49">
        <Link to="/profile" className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 flex flex-col items-center justify-center" data-id="element-50">
          <div className="w-12 h-12 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mb-2" data-id="element-51">
            <UserIcon className="w-6 h-6 text-green-600 dark:text-green-400" data-id="element-52" />
          </div>
          <span className="text-gray-900 dark:text-white font-medium" data-id="element-53">
            My Profile
          </span>
        </Link>
        <Link to="/lawajam" className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 flex flex-col items-center justify-center" data-id="element-54">
          <div className="w-12 h-12 bg-indigo-100 dark:bg-indigo-900 rounded-full flex items-center justify-center mb-2" data-id="element-55">
            <CreditCardIcon className="w-6 h-6 text-indigo-600 dark:text-indigo-400" data-id="element-56" />
          </div>
          <span className="text-gray-900 dark:text-white font-medium" data-id="element-57">
            Lawajam History
          </span>
        </Link>
      </div>
      {/* Stats Summary */}
      <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4" data-id="element-58">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-3" data-id="element-59">
          Your Stats
        </h2>
        <div className="grid grid-cols-2 gap-4" data-id="element-60">
          <div className="bg-blue-50 dark:bg-blue-900/30 rounded-lg p-3" data-id="element-61">
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-62">
              Total Duties
            </p>
            <p className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-63">
              12
            </p>
          </div>
          <div className="bg-green-50 dark:bg-green-900/30 rounded-lg p-3" data-id="element-64">
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-65">
              Lawajam Status
            </p>
            <p className="text-xl font-bold text-green-600 dark:text-green-400" data-id="element-66">
              Paid
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default Dashboard;